import React, { HTMLAttributes } from 'react';
import { env } from 'settings/env';

type Props = {
  deliveryMethod: string;
  orderId: string;
} & HTMLAttributes<HTMLAnchorElement>;

export const returnLinkByMethod: Partial<Record<string, string>> = {
  ['evri']: `https://www.evri.com/return-a-parcel`,
  ['Mondial Relay']: `https://retours.mondialrelay.com/d/${env.ENV_MONDIAL_RELAY_CLIENT_CODE}/?SiteId=Retour`,
};

export default function ReturnLink({
  deliveryMethod,
  orderId,
  ...props
}: Props): JSX.Element | null {
  const returnLink = returnLinkByMethod[deliveryMethod] || '';

  if (!returnLink) {
    return null;
  }

  return (
    <a target="_blank" rel="noreferrer" href={returnLink} {...props}>
      {deliveryMethod === 'evri' ? `${orderId}01` : orderId}
    </a>
  );
}
